// @flow

import * as React from 'react';

import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';

import { needsAuth } from '@gandi/authentication';
import { notifyDanger } from '@gandi/notifications';
import { instances } from '@gandi/redux-resource-simplehosting';

import { withTranslator } from '@gandi/translate';

import { withLogger } from 'gandi.redux-logger';

import { withRouter } from 'src/helpers/withRouter';

import type { FullState, Dispatch } from '../../types';
import { selectAdminShsUrl, selectOverviewUrl } from '../modules/urls';

import SimpleHostingRenewPresenter from './components/Presenter';
import { instanceRenew, loadInstance, loadCouponsIfRequired } from './module';

// --------------------------------------------------------------------- Connect

type OwnProps = {
  params: {
    identifier: string,
    cartId: string,
    isTrial: boolean,
  },
};

function mapStateToProps(state: FullState, ownProps: OwnProps) {
  return {
    identifier: ownProps.params.identifier,
    cartId: ownProps.params.cartId,
    isTrial: instances.selectIsTrial(state, ownProps.params.identifier),

    adminSHSURL: selectAdminShsUrl(state),
    cartOverviewUrl: selectOverviewUrl(state),
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return bindActionCreators(
    {
      notifyDanger,
      instanceRenew,
      loadInstance,
      loadCouponsIfRequired,
    },
    dispatch,
  );
}

export default (compose(
  needsAuth,
  withTranslator({ propsNamespace: 'translator' }),
  withRouter,
  withLogger('shop/SimpleHosting/Renew/index'),
  connect(mapStateToProps, mapDispatchToProps),
)(SimpleHostingRenewPresenter): React.ComponentType<{}>);
